import React, { FC } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { List, ListItem } from '@ucheba/ui/components/List/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { useSelector } from 'react-redux'
import { authSelectors } from '@ucheba/store/auth'
import { IAdmissionConditions } from '../types'
import { useAdmissionConditions } from '../bll/useAdmissionConditions'
import { useOddsAssessment } from '../../../../../../../../components/OddsAssessment/bll'

const AdmissionConditions: FC<IAdmissionConditions> = (props) => {
  const {
    requiredSubjects,
    optionalSubjects,
    additionalExams,
    hasOlympiad,
    programId,
    showButton = true,
    isSecondEducation,
    secondHigherExams,
  } = props

  const { hrefToOlympiads, hasAdditionalExamsDescriptions } = useAdmissionConditions({
    subjects: requiredSubjects,
    additionalExams,
  })
  const { selectEgeDialog, hasCurrentProbability, checkAuth } =
    useOddsAssessment(programId)
  const isAuth = useSelector(authSelectors.isAuth)

  if (!requiredSubjects && !optionalSubjects && !additionalExams && !secondHigherExams)
    return null

  if (
    requiredSubjects.length === 0 &&
    optionalSubjects.length === 0 &&
    additionalExams.length === 0
  ) {
    return null
  }

  return (
    <div>
      <Heading h3='Условия поступления' spacing='small' />

      {isSecondEducation && secondHigherExams ? (
        <div>
          <Text>{secondHigherExams}</Text>
        </div>
      ) : (
        <Grid>
          <GridCol uxs={!hasOlympiad || !hrefToOlympiads ? 24 : 12}>
            {(!!requiredSubjects?.length || !!optionalSubjects?.length) && (
              <>
                <Text color='gray50' fontSize='h4' lineHeight='h4' fontWeight='bold'>
                  {`<span style="color: #030f23">Предметы ЕГЭ</span> и минимальные баллы`}
                </Text>

                <Spacing spacing='xxsmall' />
              </>
            )}

            <List view='dots' spacing='xxsmall'>
              {requiredSubjects?.map((ege, key) => (
                <ListItem key={key}>
                  <Text firstLetterUppercase>
                    {`${ege?.exam?.subject?.name} <span style="color: #030F237F"> от ${ege.minPoints}</span>`}
                  </Text>
                </ListItem>
              ))}

              {optionalSubjects && optionalSubjects?.length > 0 && (
                <ListItem>
                  <Text>На выбор:</Text>

                  {optionalSubjects.map((ege, key) => (
                    <Text firstLetterUppercase key={key}>
                      {`${ege?.exam?.subject?.name} <span style="color: #030F237F"> от ${ege.minPoints}</span>`}
                    </Text>
                  ))}
                </ListItem>
              )}
            </List>

            {additionalExams?.length > 0 && (
              <>
                {!!optionalSubjects?.length || !!requiredSubjects?.length ? (
                  <>
                    <Spacing spacing='small' />

                    <Text
                      fontWeight='bold'
                      fontSize='h4'
                      lineHeight='h4'
                      firstLetterUppercase
                    >
                      Дополнительные экзамены
                    </Text>

                    <Spacing spacing='xxsmall' />

                    <List view='dots' spacing='xxsmall'>
                      {additionalExams?.map((exam, key) => (
                        <ListItem key={key}>
                          <Text firstLetterUppercase>{exam.title}</Text>
                        </ListItem>
                      ))}
                    </List>
                  </>
                ) : (
                  <>
                    {!hasAdditionalExamsDescriptions && (
                      <List view='dots' spacing='xxsmall'>
                        {additionalExams?.map((exam, key) => (
                          <ListItem key={key}>
                            <Text firstLetterUppercase>{exam.title}</Text>
                          </ListItem>
                        ))}
                      </List>
                    )}
                  </>
                )}
              </>
            )}

            {hasAdditionalExamsDescriptions &&
              !optionalSubjects?.length &&
              !requiredSubjects?.length && (
                <>
                  <List bordered>
                    {additionalExams?.map((exam, key) => (
                      <ListItem key={key}>
                        <Text
                          firstLetterUppercase
                          fontWeight='semibold'
                          fontSize='h4'
                          lineHeight='h4'
                        >
                          {exam.title}
                        </Text>

                        {exam.description && (
                          <>
                            <Spacing spacing='small' />

                            <Text firstLetterUppercase>{exam.description}</Text>
                          </>
                        )}
                      </ListItem>
                    ))}
                  </List>
                </>
              )}

            {!hasCurrentProbability &&
              showButton &&
              requiredSubjects &&
              requiredSubjects.length > 0 && (
                <>
                  <Spacing spacing='small' />

                  <Button
                    block
                    size='small'
                    view='outline'
                    color='blue'
                    onClick={() => {
                      checkAuth()

                      if (isAuth) {
                        selectEgeDialog.openDialog()
                      }
                    }}
                  >
                    Оценить шансы на поступление
                  </Button>
                </>
              )}
          </GridCol>

          {hasOlympiad && hrefToOlympiads && (
            <GridCol uxs={12}>
              <Text fontWeight='bold' fontSize='h4' lineHeight='h4'>
                Поступление по олимпиаде
              </Text>

              <Spacing spacing='xxsmall' />

              <Text>Можно поступить без экзаменов, победив в одной из олимпиад</Text>

              <Spacing spacing='usmall' />

              <Button size='small' view='link' color='blue' href={hrefToOlympiads}>
                Подобрать олимпиаду
              </Button>
            </GridCol>
          )}
        </Grid>
      )}
    </div>
  )
}

export default AdmissionConditions
